import { IProduct } from "src/core/products/api/products.api";

export default (product: IProduct): number | null => {
  // If there is no price data found in the product or if a price is not given
  // return with no price.
  if (!product || !product.prices || product.prices.length === 0) {
    return null;
  }

  return product.prices[ 0 ].vatValue;
};
